import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-67b3d0b4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "travel_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1));

const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_5 = {
  class: "base_details_content_second"
};
const _hoisted_6 = {
  class: "input_alert"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "scrollTop"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "套餐设置", -1));

const _hoisted_9 = {
  class: "content"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, [/*#__PURE__*/_createTextVNode("套餐设置"), /*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_11 = {
  class: "base_details_content_second"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, [/*#__PURE__*/_createTextVNode("参团设置"), /*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_13 = {
  class: "base_details_content_second"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他设置", -1));

const _hoisted_15 = {
  class: "content"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "行程安排", -1));

const _hoisted_17 = {
  class: "base_details_content_second"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品亮点", -1));

const _hoisted_19 = {
  class: "base_details_content_second"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "交通说明", -1));

const _hoisted_21 = {
  class: "base_details_content_second"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "费用说明", -1));

const _hoisted_23 = {
  class: "base_details_content_second"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "退改政策", -1));

const _hoisted_25 = {
  class: "base_details_content_second"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "须知设置", -1));

const _hoisted_27 = {
  class: "base_details_content_second"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "赠送设置", -1));

const _hoisted_29 = {
  class: "content"
};
const _hoisted_30 = {
  class: "base_screen_header"
};
const _hoisted_31 = {
  class: "dialog-footer"
};
import UploadVideo from "@com/upload/UploadVideo.vue";
import BackTitleView from "@com/BackTitleView.vue";
import DynamicParams from "@com/DynamicParams.vue";
import SelectCity from "@com/SelectCity.vue";
import IntegralTravelSetMeal from "@com/integral/IntegralTravelSetMeal.vue";
import GroupSetting from "@/components/integral/groupSetting/IntegralTravelPrice.vue";
import RouteManager from "@com/travel/RouteManager.vue";
import MapSelectAddress from "@com/MapSelectAddress.vue";
import ChooseAdditional from "@com/travel/ChooseAdditional.vue";
import { ref, reactive, nextTick, watch } from 'vue';
import useRoute from "@util/router";
import { Search, Warning } from "@element-plus/icons-vue";
import api from "@api/travel";
import travelConfigApi from "@api/travelConfig";
import $ from "@util/base";
import { $box, $msg } from "@/common/ui/msg";
import DataCollectTable from "@/components/table/DataCollectTable.vue";
import { COLUMN_TYPE, OP_KEY, OPERATIONS, operationsHander } from "@/components/table/tableOperations";
import couponApi from "@/api/coupon";
export default {
  __name: 'IntegralTravelDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var isApproval = false;
    var title = "旅游详情";
    var modifyMode = false;
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "旅游详情";
        getData();
      },
      add: () => {
        title = "新增旅游";
      },
      modify: () => {
        modifyMode = true;
        title = "修改旅游";
        getData();
      },
      examine: () => {
        readOnly = true;
        isApproval = true;
        title = "旅游详情";
        getData();
      }
    });
    const groupSetting = ref(null);
    const setMealData = ref([]);
    const programme = ref([]);
    const typeOptions = ref([]); // const baseOptions = ref([])

    const labelOptions = ref([]);
    const naturesOptions = ref([]);
    const provinceOptions = ref([]);
    const visitorOptions = [{
      value: "1051001",
      label: '不强制填写'
    }, {
      value: "1051002",
      label: '至少填写一人'
    }, {
      value: "1051003",
      label: '全部填写'
    }];
    const featureInfo = ref();
    const travelWay = ref();
    const expenseAftersale = ref();

    function sendProgramme(val) {
      programme.value = val;
    }

    getConfig();

    function getConfig() {
      travelConfigApi.category(val => {
        typeOptions.value = val;
      }); // travelConfigApi.base(val => { baseOptions.value = val })

      travelConfigApi.label(val => {
        labelOptions.value = val;
      });
      travelConfigApi.natures(val => {
        naturesOptions.value = val;
      });
      travelConfigApi.province(val => {
        provinceOptions.value = val;
      });
    }

    const activeName = ref(0);
    watch(() => activeName.value, val => {
      if (val == 1) {
        nextTick(() => {
          document.getElementById("scrollTop").scrollIntoView();
        });
      }
    });

    function tabChange(type) {
      if (activeName.value == 0) {
        basicFormRef.value.validate((valid, fields) => {
          if (valid) {
            activeName.value = Number(activeName.value) + 1;
            setTimeout(() => {
              document.getElementById("scrollTop").scrollIntoView();
            }, 300);
          } else {
            $msg.error("请完善基本信息");
          }
        });
        return;
      } else if (activeName.value == 1) {
        if (!setMealDynamic.value.chack()) {
          $msg.error("请完善套餐设置");
          return;
        }

        if (!groupSetting.value.chack()) {
          $msg.error("请完善参团设置");
          return;
        }
      }

      if (type == "next") {
        activeName.value = Number(activeName.value) + 1;
      } else {
        activeName.value = Number(activeName.value) - 1;
      }
    }

    const basicFormRef = ref(null);
    const basicForm = ref({
      travelType: "1042001",
      categoryCode: null,
      travelName: null,
      // shopCode: null,
      startArea: null,
      targetArea: null,
      targetShopCode: null,
      destLat: null,
      destLng: null,
      // tourGroupPeopleNum: null,
      picList: [],
      descList: [],
      // tags: [],
      // joinTypeId: null,
      guestRequire: null,
      flowStatus: null,
      flowCode: null,
      deadlineTimeDay: null,
      deadlineTimeHour: null,
      deadlineTimeMinute: null,
      // stockNum: null
      payType: '',
      payTypeList: [],
      couponItemList: []
    });

    function setStartArea(value) {
      basicForm.value.startArea = value;
    } // function setTargetArea(value) {
    //   basicForm.value.targetArea = value;
    // }


    function selectAddress(data) {
      basicForm.value.destLat = data.lat + "";
      basicForm.value.destLng = data.lng + "";
      basicForm.value.targetShopCode = data.address;
    }

    function setTargetCode(value) {
      basicForm.value.targetShopCode = value;
    }

    const chooseAdditionalRef = ref(null);

    function openChooseAdditional() {
      chooseAdditionalRef.value.show();
    }

    function chooseAdditional(data) {
      console.log("附加费用选中数据：", data);

      for (const item of data) {
        premiumDynamic.value.addData(item);
      }
    }

    const expenseDescriptionFormRef = ref(null);
    const expenseDescriptionForm = ref({
      expenseContain: null,
      expenseExclude: "1、单房差或加床。\r\n2、因交通延阻、罢工、天气、飞机机器故障航班取消或更改时间等不可抗力原因所引致的额外费用。\r\n3、酒店押金、酒店内洗衣、理发、电话、传真、收费电视、饮品、烟酒等个人消费。\r\n4、航空险、火车险、旅游人身意外保险，请自行购买。\r\n5、地面服务费(如出发机场接送服务、行李物品保管费、托运行李超重费等)。\r\n6、自由活动期间的餐食费和交通费\r\n7、因旅游者违约、自身过错、自身疾病导致的人身财产损失而额外支付的费用。\r\n8、因景区价格调整产生的门票差价。景区内耳麦、讲解器等。"
    });
    const expenseDescriptionRules = {
      expenseContain: [{
        required: true,
        message: "请输入费用包含说明",
        trigger: "blur"
      }],
      expenseExclude: [{
        required: true,
        message: "请输入费用不含说明",
        trigger: "blur"
      }]
    };
    const basicRules = {
      categoryCode: [{
        required: true,
        message: "请选择商品分类",
        trigger: "change"
      }],
      travelName: [{
        required: true,
        message: "请输入商品名称",
        trigger: "blur"
      }],
      // shopCode: [{
      //   required: true,
      //   message: '请选择归属基地',
      //   trigger: 'change',
      // }],
      targetArea: [{
        required: true,
        message: '请选择目的地',
        trigger: 'change'
      }],
      // targetShopCode: [
      //   {
      //     required: true,
      //     message: "请填入目的地",
      //   },
      // ],
      // tourGroupPeopleNum: [
      //   {
      //     required: true,
      //     message: "请输入成团人数",
      //     trigger: "blur",
      //   },
      // ],
      picList: [{
        required: true,
        type: "array",
        message: "请上传产品封面",
        trigger: "blur"
      }],
      descList: [{
        required: true,
        type: "array",
        message: "请上传产品简介",
        trigger: "blur"
      }] // stockNum: [{
      //   required: true,
      //   message: '请输入产品库存',
      //   trigger: 'blur',
      // }]
      // payTypeList: [{
      //   required: true,
      //   message: '请选择支付方式',
      //   trigger: 'change',
      // }],

    };
    const setMealDynamic = ref(null);
    const routeManager = ref(null);
    const routeManagerData = ref([]);
    const premiumTemplate = {
      extraName: null,
      extraPrice: null
    };
    const premiumData = ref([]);
    const premiumDynamic = ref(null);

    function getPremiumValue() {
      let data = premiumDynamic.value.getValue();
      data.remove(e => {
        return $.isEmpty(e.groupName) && $.isNull(e.extraName) && $.isNull(e.extraPrice) && $.isNull(e.picUrl);
      });

      if (data.length <= 0) {
        return null;
      } else {
        for (const item of data) {
          if ($.isEmpty(item.groupName)) {
            $msg.error("请输入附加费用一级名称");
            return false;
          }

          if ($.isNull(item.extraName)) {
            $msg.error("请输入附加费用二级名称");
            return false;
          }

          if ($.isNull(item.extraPrice)) {
            $msg.error("请输入附加费用金额");
            return false;
          }

          if ($.isNull(item.picUrl)) {
            $msg.error("请上传说明图片");
            return false;
          }
        }

        return data;
      }
    }

    const noticeTemplate = {
      title: null,
      intro: null
    };
    const noticeData = ref([]);
    const noticeDynamic = ref(null);

    function getNoticeDynamic() {
      let data = noticeDynamic.value.getValue();
      data.remove(e => {
        return $.isEmpty(e.title) && $.isNull(e.intro);
      });

      if (data.length <= 0) {
        return null;
      }

      for (const item of data) {
        if ($.isEmpty(item.title)) {
          $msg.error("请输入须知标题");
          return false;
        }

        if ($.isNull(item.intro)) {
          $msg.error("请输入须知内容");
          return false;
        }
      }

      return data; // if (data.length <= 0) {
      //   $msg.error("请设置须知")
      //   return false
      // } else {
      //   for (const item of data) {
      //     if ($.isEmpty(item.title)) {
      //       $msg.error("请输入须知标题")
      //       return false
      //     }
      //     if ($.isNull(item.intro)) {
      //       $msg.error("请输入须知内容")
      //       return false
      //     }
      //   }
      //   return data
      // }
    }

    function setDeadlineTime() {
      if ($.isEmpty(basicForm.value.deadlineTimeDay) && $.isEmpty(basicForm.value.deadlineTimeHour) && $.isEmpty(basicForm.value.deadlineTimeMinute)) {
        basicForm.value.deadlineTime = null;
        return true;
      } else {
        var time = [0, 0, 0];

        if ($.isNotEmpty(basicForm.value.deadlineTimeDay)) {
          time[0] = parseInt(basicForm.value.deadlineTimeDay);
        }

        if ($.isNotEmpty(basicForm.value.deadlineTimeHour)) {
          time[1] = parseInt(basicForm.value.deadlineTimeHour);
        }

        if ($.isNotEmpty(basicForm.value.deadlineTimeMinute)) {
          time[2] = parseInt(basicForm.value.deadlineTimeMinute);
        }

        basicForm.value.deadlineTime = time;
      }
    }

    var intervalSave = $.interval(save, 2500);

    function save(isExamine) {
      basicFormRef.value.validate((valid, fields) => {
        if (valid) {
          setDeadlineTime(); //校验基本信息

          let paramsData = {
            isPass: isExamine ? 2 : 1,
            // 是否提交审核 1 不提交 2提交审核
            travelItem: basicForm.value,
            otherItem: {}
          };

          if ($.isNotEmpty(paramsData.travelItem.couponItemList)) {
            paramsData.travelItem.couponItemList = paramsData.travelItem.couponItemList.map((e, index) => {
              e.sort = e.sort || index + 1;
              return e;
            });
          } // 标记积分商城


          paramsData.travelItem.belongMall = 1066002;

          if (!setMealDynamic.value.chack()) {
            console.log(setMealDynamic.value.chack());
            $msg.error("请完善套餐设置");
            return;
          } // 套餐


          let setMealData = setMealDynamic.value.getValue(); //参团

          let groupSettingData = groupSetting.value.getValue(); // 行程安排

          let routeData = routeManager.value.getValue(); // 须知

          let noticeData = getNoticeDynamic();

          if (setMealData != false && groupSettingData != false && routeData != false && noticeData != false) {
            paramsData.packageItems = setMealData;
            paramsData.travelStockItems = groupSettingData;
            paramsData.otherItem.expenseItems = premiumData.value;

            if ($.isNotEmpty(featureInfo.value)) {
              paramsData.otherItem.featureInfo = featureInfo.value;
            }

            if ($.isNotEmpty(travelWay.value)) {
              paramsData.otherItem.travelWay = travelWay.value;
            }

            if ($.isNotEmpty(expenseAftersale.value)) {
              paramsData.otherItem.expenseAftersale = expenseAftersale.value;
            }

            paramsData.otherItem.travelPlanItems = routeData;
            paramsData.otherItem.tipItems = noticeData; //校验费用说明

            paramsData.otherItem.expenseDescriptionItem = expenseDescriptionForm.value;
            console.log(urlQuery.type);
            $.handleCRU(urlQuery.type, {
              add: () => {
                api.add(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              },
              modify: () => {
                paramsData.packageItems = roomItemDelHander(setMealData);
                api.update(paramsData, () => {
                  $msg.succ("保存成功");
                  route.go(-1);
                });
              }
            });
          }
        } else {
          $msg.error("请完善基本信息");
        }
      });
    } // 被删除的房型数据还在只是设置flag为0


    function roomItemDelHander(packageData) {
      if (oldPackageItems) {
        for (const item of oldPackageItems) {
          if (packageData.find(e => {
            return e.id === item.id;
          }) == null) {
            packageData.push({
              id: item.id,
              flag: 0
            });
          }
        }
      }

      console.log(packageData);
      return packageData;
    }

    var oldPackageItems = null;

    function getData() {
      api.details(route.query().code, val => {
        basicForm.value = val.travelItem;
        let tagList = []; // val.travelItem.tags.split(",").forEach(item => {
        //   tagList.push(parseInt(item))
        // });
        // basicForm.value.tags = tagList;

        setMealData.value = val.packageItems;
        groupSetting.value.improtData(val.travelStockItems);
        const deadlineTime = val.travelItem.deadlineTime;

        if (deadlineTime != null && deadlineTime.length >= 3) {
          basicForm.value.deadlineTimeDay = deadlineTime[0];
          basicForm.value.deadlineTimeHour = deadlineTime[1];
          basicForm.value.deadlineTimeMinute = deadlineTime[2];
        }

        let data = [];

        for (const item of val.packageItems) {
          data.push({
            packageName: item.name
          });
        }

        sendProgramme(data);

        if ($.isNotEmpty(val.otherItem.expenseItems)) {
          premiumData.value = val.otherItem.expenseItems;
        }

        routeManagerData.value = val.otherItem.travelPlanItems;

        if ($.isNotEmpty(val.otherItem.featureInfo)) {
          featureInfo.value = val.otherItem.featureInfo;
        }

        if ($.isNotEmpty(val.otherItem.travelWay)) {
          travelWay.value = val.otherItem.travelWay;
        }

        if ($.isNotEmpty(val.otherItem.expenseAftersale)) {
          expenseAftersale.value = val.otherItem.expenseAftersale;
        }

        expenseDescriptionForm.value = val.otherItem.expenseDescriptionItem;
        noticeData.value = val.otherItem.tipItems;
        oldPackageItems = val.packageItems;
      });
    } // 审批通过


    function approvalPass() {
      $box.open("通过", "确认该商品审批通过", () => {
        api.approval(basicForm.value.flowCode, "1007004", "", () => {
          $msg.succ("审批成功");
          route.go(-1);
        });
      });
    } // 驳回


    function approvalRefusal() {
      $box.input("确认驳回", "驳回原因", null, val => {
        api.approval(basicForm.value.flowCode, "1007003", val, () => {
          $msg.succ("驳回成功");
          route.go(-1);
        });
      });
    }

    const addCouponDialog = ref(false);
    const couponName = ref("");
    const couponDataTableRef = ref(null);
    const couponData = ref([]);
    const couponDataConfig = ref({
      showIndex: true,
      showSelection: true,
      column: [{
        label: "名称",
        prop: "name",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "当前状态",
        prop: "enableStatusName",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });
    const couponDataSize = ref(10);
    const couponDataPage = ref(1);
    const couponDataTotal = ref(0);
    const couponDataHandler = operationsHander();
    const couponItemListHandler = operationsHander();
    const couponItemListConfig = ref({
      showIndex: true,
      operations: {
        label: '操作',
        width: 200,
        operations: getOperations
      },
      column: [{
        label: "数量",
        prop: "num",
        type: COLUMN_TYPE.input,
        operationsKey: OPERATIONS.input,
        width: 100
      }, {
        label: "名称",
        prop: "couponName",
        width: 200
      }, {
        label: "已发放",
        prop: "provideNum",
        width: 100
      }, {
        label: "已核销",
        prop: "usedNum",
        width: 100
      }, {
        label: "有效范围",
        prop: "lifespan"
      }, {
        label: "优惠内容",
        prop: "couponDesc"
      }, {
        label: "创建时间",
        prop: "createTime"
      }, {
        label: "创建人",
        prop: "creator",
        width: 100
      }]
    });

    function getOperations(data) {
      return [OPERATIONS.del];
    }

    couponItemListHandler.install(OP_KEY.delete, (data, row) => {
      $box.open("移除", "确认移除优惠券：" + data.couponName, () => {
        let index = basicForm.value.couponItemList.findIndex(e => {
          return e.couponCode === data.couponCode;
        });
        basicForm.value.couponItemList.splice(index, 1);
      });
    });

    function showAddCouponDialog() {
      getCouponData();
      addCouponDialog.value = true;
    }

    function getCouponData() {
      couponApi.list({
        name: couponName.value,
        page: couponDataPage.value,
        size: couponDataSize.value
      }, val => {
        couponData.value = val.list;
        couponDataTotal.value = val.total;
      });
    }

    function couponDataPageChange(type, val) {
      if (type == 'page') {
        couponDataPage.value = val;
      } else if (type == 'size') {
        couponDataSize.value = val;
      }

      getCouponData();
    }

    function couponDataSelectedSubmit() {
      let selected = couponDataTableRef.value.getSelectData();

      if ($.isEmpty(selected)) {
        $msg.error("请选择优惠券");
        return;
      } else {
        selected = selected.filter(f => {
          return !basicForm.value.couponItemList.some(s => {
            return s.couponCode === f.couponCode;
          });
        }).map(e => {
          return {
            couponCode: e.couponCode,
            couponName: e.name,
            provideNum: e.provideNum,
            usedNum: e.usedNum,
            lifespan: e.lifespan,
            couponDesc: e.couponDesc,
            createTime: e.createTime,
            creator: e.creator,
            sort: e.sort,
            num: 1
          };
        });
        basicForm.value.couponItemList = basicForm.value.couponItemList.concat(selected);
        addCouponDialog.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_UploadPicture = _resolveComponent("UploadPicture");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => activeName.value = $event),
            type: "border-card",
            class: "base_details_tabs",
            lazy: false
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: 0
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
                ref_key: "basicFormRef",
                ref: basicFormRef,
                model: basicForm.value,
                disabled: _unref(readOnly),
                rules: basicRules,
                "label-width": "100px",
                class: "base_details_form"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "旅行类型",
                  prop: "travelType",
                  required: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.value.travelType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.travelType = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_radio, {
                      label: "1042001"
                    }, {
                      default: _withCtx(() => [_createTextVNode("普通旅行")]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "产品分类",
                  prop: "categoryCode"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.categoryCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.categoryCode = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "产品名称",
                  prop: "travelName"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.travelName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.travelName = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "出发地",
                  prop: "startArea"
                }, {
                  default: _withCtx(() => [_createVNode(SelectCity, {
                    value: basicForm.value.startArea,
                    onSetCityCode: setStartArea
                  }, null, 8, ["value"]), _createElementVNode("span", _hoisted_6, [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Warning))]),
                    _: 1
                  }), _createTextVNode(" 出发地为空时，默认从全国出发 ")])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "目的地",
                  prop: "targetArea"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: basicForm.value.targetArea,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.value.targetArea = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinceOptions.value, (item, index) => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "详细地址"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
                    modelValue: basicForm.value.targetShopCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => basicForm.value.targetShopCode = $event),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"]), _createVNode(MapSelectAddress, {
                    class: "selectMap",
                    position: [basicForm.value.destLng, basicForm.value.destLat],
                    onSelect: selectAddress,
                    disabled: _unref(readOnly)
                  }, null, 8, ["position", "disabled"])])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "产品封面",
                  prop: "picList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_UploadPicture, {
                    modelValue: basicForm.value.picList,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => basicForm.value.picList = $event),
                    limit: 10,
                    imgSize: _unref($).describeImgSize(),
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "imgSize", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "产品简介",
                  prop: "descList"
                }, {
                  default: _withCtx(() => [_createVNode(_component_UploadPicture, {
                    modelValue: basicForm.value.descList,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => basicForm.value.descList = $event),
                    limit: 50,
                    fileSize: _unref($).imgFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "产品视频",
                  prop: "videoList"
                }, {
                  default: _withCtx(() => [_createVNode(UploadVideo, {
                    modelValue: basicForm.value.videoList,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => basicForm.value.videoList = $event),
                    limit: 1,
                    fileSize: _unref($).videoFileSize(),
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "fileSize", "disabled"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "游客信息"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: basicForm.value.guestRequire,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => basicForm.value.guestRequire = $event)
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(visitorOptions, (item, index) => {
                      return _createVNode(_component_el_radio, {
                        key: index,
                        label: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                        _: 2
                      }, 1032, ["label"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "下单截止"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 出行前 "), _createVNode(_component_el_input, {
                    class: "closing_input",
                    type: "number",
                    modelValue: basicForm.value.deadlineTimeDay,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => basicForm.value.deadlineTimeDay = $event),
                    modelModifiers: {
                      number: true
                    },
                    onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')"
                  }, null, 8, ["modelValue"]), _createTextVNode(" 天的 "), _createVNode(_component_el_select, {
                    class: "closing_select",
                    modelValue: basicForm.value.deadlineTimeHour,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => basicForm.value.deadlineTimeHour = $event),
                    placeholder: " "
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n, index) => {
                      return _createVNode(_component_el_option, {
                        key: index,
                        label: index < 10 ? `0${index}` : index,
                        value: index < 10 ? `0${index}` : index
                      }, null, 8, ["label", "value"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"]), _createTextVNode(" 时: "), _createVNode(_component_el_select, {
                    class: "closing_select",
                    modelValue: basicForm.value.deadlineTimeMinute,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => basicForm.value.deadlineTimeMinute = $event),
                    placeholder: " "
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n, index) => {
                      return _createVNode(_component_el_option, {
                        key: index,
                        label: index < 10 ? `0${index}` : index,
                        value: index < 10 ? `0${index}` : index
                      }, null, 8, ["label", "value"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"]), _createTextVNode(" 分前可预订 ")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model", "disabled"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: 1
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_8]),
                _: 1
              })]),
              default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(IntegralTravelSetMeal, {
                ref_key: "setMealDynamic",
                ref: setMealDynamic,
                data: setMealData.value,
                readOnly: _unref(readOnly),
                modify: _unref(modifyMode),
                onProgramme: sendProgramme
              }, null, 8, ["data", "readOnly", "modify"])]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(GroupSetting, {
                ref_key: "groupSetting",
                ref: groupSetting
              }, null, 512)])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: 2
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_14]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(RouteManager, {
                ref_key: "routeManager",
                ref: routeManager,
                data: routeManagerData.value,
                travelProgramme: programme.value,
                readOnly: _unref(readOnly)
              }, null, 8, ["data", "travelProgramme", "readOnly"])]), _hoisted_18, _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_form, {
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "产品亮点"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: featureInfo.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => featureInfo.value = $event),
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled"])]), _hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_form, {
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "交通说明"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: travelWay.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => travelWay.value = $event),
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled"])]), _hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_form, {
                ref_key: "expenseDescriptionFormRef",
                ref: expenseDescriptionFormRef,
                model: expenseDescriptionForm.value,
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "费用包含",
                  prop: "expenseContain"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: expenseDescriptionForm.value.expenseContain,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => expenseDescriptionForm.value.expenseContain = $event),
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "费用不含",
                  prop: "expenseExclude"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: expenseDescriptionForm.value.expenseExclude,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => expenseDescriptionForm.value.expenseExclude = $event),
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["model", "disabled"])]), _hoisted_24, _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_form, {
                "label-width": "100px",
                class: "base_details_form",
                disabled: _unref(readOnly)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "退改政策"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: expenseAftersale.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => expenseAftersale.value = $event),
                    type: "textarea",
                    rows: 6,
                    placeholder: "请输入",
                    clearable: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["disabled"])]), _hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(DynamicParams, {
                ref_key: "noticeDynamic",
                ref: noticeDynamic,
                template: noticeTemplate,
                data: noticeData.value,
                operation: _unref($).DPMoveOperation(_unref(readOnly)),
                addText: "添加须知"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  label: "须知内容",
                  align: "center"
                }, {
                  default: _withCtx(scope => [_createVNode(_component_el_input, {
                    class: "m_b_10",
                    modelValue: scope.row.title,
                    "onUpdate:modelValue": $event => scope.row.title = $event,
                    placeholder: "请输入须知标题",
                    clearable: "",
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_el_input, {
                    modelValue: scope.row.intro,
                    "onUpdate:modelValue": $event => scope.row.intro = $event,
                    rows: 3,
                    type: "textarea",
                    placeholder: "请输入须知内容",
                    clearable: "",
                    disabled: _unref(readOnly)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["data", "operation"])])])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: 3
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_28]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
                onClick: showAddCouponDialog,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("添加优惠券")]),
                _: 1
              }), _createVNode(DataCollectTable, {
                ref: "couponItemListTableRef",
                data: basicForm.value.couponItemList,
                config: couponItemListConfig.value,
                isRoute: false,
                onOperationsHander: _unref(couponItemListHandler).receive,
                isPage: false
              }, null, 8, ["data", "config", "onOperationsHander"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
            title: "添加优惠券",
            modelValue: addCouponDialog.value,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => addCouponDialog.value = $event),
            width: "80%",
            "destroy-on-close": ""
          }, {
            footer: _withCtx(() => [_createElementVNode("span", _hoisted_31, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: couponDataSelectedSubmit
            }, {
              default: _withCtx(() => [_createTextVNode("保存")]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[20] || (_cache[20] = $event => addCouponDialog.value = false)
            }, {
              default: _withCtx(() => [_createTextVNode("取消")]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_form, {
              inline: true,
              class: "base_search_form",
              onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: couponName.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => couponName.value = $event),
                  "onKeyup[native]": getCouponData,
                  onChange: getCouponData,
                  placeholder: "优惠券名称",
                  clearable: "",
                  "suffix-icon": _unref(Search)
                }, null, 8, ["modelValue", "suffix-icon"])]),
                _: 1
              })]),
              _: 1
            })]), _createVNode(DataCollectTable, {
              ref_key: "couponDataTableRef",
              ref: couponDataTableRef,
              data: couponData.value,
              config: couponDataConfig.value,
              isRoute: false,
              onOperationsHander: _unref(couponDataHandler).receive,
              total: couponDataTotal.value,
              onPageChange: couponDataPageChange
            }, null, 8, ["data", "config", "onOperationsHander", "total"])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 512), [[_vShow, activeName.value == 0]]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[23] || (_cache[23] = $event => tabChange('last'))
          }, {
            default: _withCtx(() => [_createTextVNode("上一步")]),
            _: 1
          }, 512), [[_vShow, activeName.value != 0]]), _withDirectives(_createVNode(_component_el_button, {
            onClick: _cache[24] || (_cache[24] = $event => tabChange('next')),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("下一步 ")]),
            _: 1
          }, 512), [[_vShow, activeName.value != 2 && activeName.value != 3]]), !_unref(readOnly) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _cache[25] || (_cache[25] = $event => _unref(intervalSave)(false))
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          }, 512)), [[_vShow, activeName.value == 2 || activeName.value == 3]]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: approvalPass,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批通过 ")]),
            _: 1
          }, 512)), [[_vShow, (activeName.value === 2 || activeName.value == 3) && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true), _unref(isApproval) ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            onClick: approvalRefusal,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("审批驳回 ")]),
            _: 1
          }, 512)), [[_vShow, (activeName.value === 2 || activeName.value == 3) && basicForm.value.flowStatus == '1007002']]) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(ChooseAdditional, {
          ref_key: "chooseAdditionalRef",
          ref: chooseAdditionalRef,
          onChooseAdditional: chooseAdditional
        }, null, 512)]),
        _: 1
      })]);
    };
  }

};